import Table from "react-bootstrap/Table";
import React from 'react';
import moment from "moment";
import history from "../../assets/icons/timer1.svg";
import { marketPlaceBackDetails } from "../../store/actions/marketplace.action";
import { featureSubmodulePermission, permssionView, settings, SUBF_MARKETPLACEINTEGRATION } from "../../constant";
import { checkPermission } from "../../config/utils";
import PropTypes from "prop-types";

const IntegrationList = (props) => {
    const {
        sortingColumn,
        handleSortingColumn,
        sortOrder,
        listData,
        navigate,
        loader,
        defaultFilterData,
        dispatch
    } = props;

    const renderColumnHeader = (colName, type) => {
        return (
            <button
                className={(sortingColumn === type) ? "active sortBtn" : "sortColumn sortBtn"}
                onClick={(e) => handleSortingColumn(e, type)}
            >
                {colName}
                <i
                    className={(sortingColumn === type && sortOrder === "asc") ? "fa fa-arrow-up" : "fa fa-arrow-down"}
                    aria-hidden="true"
                ></i>
            </button>
        )
    }


    const handleIntegrationRedirect = (integration) => {
        dispatch(marketPlaceBackDetails(defaultFilterData));
        navigate(`/market-place/${integration.integration_name}`, {
            state: {
                data: integration,
                isIntegration: true,
                backUrl: '/marketplace-integration',
            },
        });
    }

    const renderLoading = () => {
        return (
            <tr className="table-rw-batch">
                <td colSpan={7} align="center">Loading...</td>
            </tr>
        )
    }
    const renderNoRecord = () => {
        return (
            <tr className="table-rw-batch">
                <td colSpan={7} align="center">No Record Found</td>
            </tr>
        )
    }

    const handleHistoryPage = (rowData) => {
        dispatch(marketPlaceBackDetails(defaultFilterData));
        navigate(
            `/MarketplaceIntegration/history/fd-${rowData?.integration_id}-3pl`,
            {
                state: {
                    rowData,
                },
            }
        );
    };

    return (
        <Table className="table  table-height cus-left-right-col-layout">
            <thead border="Green">
                <tr>
                    <th className="marketplace-table">
                        {renderColumnHeader('Name', 'integration_name')}
                    </th>
                    <th className="marketplace-table">
                        {renderColumnHeader('Type', 'type')}
                    </th>
                    <th>
                        Status
                    </th>
                    <th className="marketplace-table">
                        {renderColumnHeader('Active', 'active')}
                    </th>
                    <th className="marketplace-table">
                        {renderColumnHeader('Total Records', 'total_orders')}
                    </th>
                    <th>
                        {renderColumnHeader('Date', 'date')}
                    </th>
                    <th className="sticky">History</th>
                </tr>
            </thead>
            <tbody className="tbl-bt-body">
                {!loader && listData && listData.length > 0 && (
                    <>
                        {listData.map((item) => (
                            <tr className="table-rw-batch" key={item.listId}>
                                <td>
                                    {item.active ? checkPermission(settings, SUBF_MARKETPLACEINTEGRATION, permssionView, featureSubmodulePermission, props.employeePermissions) && (
                                        <button className="linkIntegration sortBtn normalTxt" onClick={() => handleIntegrationRedirect(item)}>{item.integration_name}</button>
                                    ) : (
                                        <span>{item.integration_name}</span>
                                    )}
                                </td>
                                <td>{item.type}</td>
                                <td>{item.pending_shipment_statuses === 'Completed' ?
                                    <span className="activeStatus">OK</span>
                                    : <span className="errorStatus">{item.pending_shipment_statuses}</span>}</td>
                                <td>
                                    {item.active ? <i className="fa fa-check" aria-hidden="true"></i> : <i className="fa fa-times" aria-hidden="true"></i>}
                                </td>
                                <td>{item.total_orders}</td>
                                <td>{item.order_received_date ? moment(item.order_received_date).format("MM-DD-YYYY") : '-'}</td>
                                <td className="sticky">
                                    {checkPermission(settings, SUBF_MARKETPLACEINTEGRATION, permssionView, featureSubmodulePermission, props.employeePermissions) && (
                                        <button
                                            type="button"
                                            className="history-Icon-btn sortBtn"
                                            onClick={() => handleHistoryPage(item)}
                                        >
                                            <img src={history} alt="View history" className="history-Icon" />
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </>
                )}
                {loader && (renderLoading())}
                {!loader && listData.length === 0 && renderNoRecord()}
            </tbody >
        </Table >

    );
};

IntegrationList.propTypes = {
    sortingColumn: PropTypes.string,
    handleSortingColumn: PropTypes.func,
    sortOrder: PropTypes.string,
    listData: PropTypes.array,
    navigate: PropTypes.func,
    loader: PropTypes.bool,
    defaultFilterData: PropTypes.object,
    dispatch: PropTypes.func,
    employeePermissions: PropTypes.array,
};

export default IntegrationList;
